export default __webpack_public_path__ + "static/media/awc-white.376501e1.svg";